module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Export")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "inputWrap"
  }, [_c('v-select', {
    attrs: {
      "placeholder": "Teknikker",
      "label": "name",
      "options": _vm.technicians
    },
    model: {
      value: (_vm.technician),
      callback: function($$v) {
        _vm.technician = $$v
      },
      expression: "technician"
    }
  }), _vm._v(" "), (_vm.localErrors.technician) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.technician)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_vm._v("Nei")])]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send()
      }
    }
  }, [_vm._v("Send")])])]), _vm._v(" "), _c('div', {
    staticClass: "mpsCancelBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sentiment_very_satisfied")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', [_vm._v("Velg mottaker")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5318fdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/tags/ExportDialog.vue
// module id = 120
// module chunks = 0